// Single source of truth for the app's content-card surface: a flat card that
// sits on the page canvas - 12px corners (rounded-xl) and a 1px hairline in the
// design-system `line` colour (#dedee0) on the white surface. No drop shadow -
// the design system is flat; shadows are reserved for floating chrome (menus,
// popovers). Cards that need a tinted fill use `cardOutline` and supply their
// own bg-* (e.g. bg-slate-50). Inline one-off cards across the app mirror these
// exact tokens; the reused card components (WidgetCard, SectionCard, SettingsPage)
// consume the constants directly so the high-frequency surfaces never drift.
export const cardSurface = 'rounded-xl border border-line bg-surface';
export const cardOutline = 'rounded-xl border border-line';
